import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class PluginTypes extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'plugin-types';
    }
    getDirectiveType() {
        return DirectiveType.Document;
    }
    getMinimumCspVersion() {
        return 2;
    }
}
